var common = require("../../utiles/common.js")
var service = require("../../utiles/service.js")

module.exports = {
    register: function () {
        document.createElement('work-header')
        ko.components.register('work-header', {
            viewModel: function (params) {
                var $this = this;
                var workType = location.hash.replace("#/workflow/", "").split('/')[0];
                console.log(workType)
                $this.type = ko.observable();
                $this.type(workType);
                $this.current = params.current;
                $this.workType = function(type){
                    $this.type(type);
                    common.redirectTo("/#/workflow/"+type);
                }

                $this.tobeandited = function(){
                    common.redirectTo("/#/tobeandited");
                }

                $this.goAppList = function(){
                    common.redirectTo("/#/accountApply");
                }
            },
            template: require("./workHeader.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/workflow/WorkHeader.js
// module id = 150
// module chunks = 0